export default {"src":"/_next/static/media/dominican-republic.d84af983.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};